module.exports = __webpack_public_path__ + "img/Logo b&w.b7c1454c.png";